import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Pageheader } from './global-components/page-header';
import PropertySection from './section-components/property-section';
import bgImage from '../assets/img/bg/property.webp';
import CommercialFilter from './common/CommercialFilter';

const CommercialPage = () => {
    const location = useLocation();
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [filters, setFilters] = useState({
        type: 'commercial',
        keyword: '',
        area: '',
        sqYards: ''
    });

    // Handle incoming filters from navigation
    useEffect(() => {
        if (location.state?.filters && location.state?.fromSearch) {
            const incomingFilters = location.state.filters;
            const mappedFilters = {
                ...incomingFilters,
                type: 'commercial', // Ensure type stays commercial for this page
                // Map size fields appropriately
                sqYards: incomingFilters.sqYards || incomingFilters.size || ''
            };

            setFilters(mappedFilters);

            // If there are actual search criteria, trigger search mode
            const hasSearchCriteria = incomingFilters.keyword ||
                incomingFilters.area ||
                incomingFilters.sqYards ||
                incomingFilters.size;

            if (hasSearchCriteria) {
                setIsSearchMode(true);
            }
        }
    }, [location.state]);

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // Don't set search mode for filter changes - only for explicit search
    };

    const handleSearch = (searchFilters, isSearch = false) => {
        console.log('Searching with filters:', searchFilters);
        console.log('isSearch flag:', isSearch);
        setFilters(searchFilters);
        if (isSearch) {
            console.log('Setting search mode to true');
            setIsSearchMode(true); // Set search mode when search is triggered
            // Reset search mode after a brief delay to allow the effect to trigger
            setTimeout(() => {
                setIsSearchMode(false);
            }, 100);
        }
    };

    return (
        <div>
            <Pageheader headertitle="Commercial Properties" bgImage={bgImage} />
            <CommercialFilter
                filters={filters}
                onFilterChange={handleFilterChange}
                onSearch={handleSearch}
            />
            <PropertySection
                type="commercial"
                title="Looking for commercial plots for sale in Amaravati?"
                description="Royale Spaces is a top-rated real estate company in Amaravati, offering verified and CRDA-approved commercial plots in Amaravati, along with select open plots in Amaravati for smart investors. Our commercial plots are strategically located near key infrastructure—business zones, expressways, educational hubs, and upcoming government districts—offering exceptional visibility and long-term value. Each property comes with clear titles, complete legal documentation, and transparent pricing, ensuring you invest with confidence."
                filters={filters}
                isSearchMode={isSearchMode}
                initialPropertiesPerPage={6}
            />
        </div>
    );
};

export default CommercialPage;
